import { gql } from 'graphql-query-contracts';

export const updateUnit = gql(`
  mutation UpdateUnit($propertyId: UUID!, $unitId: String!, $unit: UnitInput!) {
    updateUnit(propertyId: $propertyId, unitId: $unitId, unit: $unit)
  }
`);

export const updateUnitAndReferencesMutation = gql(`
  mutation UpdateUnitAndReferences(
    $propertyId: UUID!
    $unitId: String!
    $unit: UnitInput!
    $addExternalReferences: [ExternalReferenceAddInput!]!
    $removeExternalReferences: [ExternalReferenceRemoveInput!]!
  ) {
    updateUnit(propertyId: $propertyId, unitId: $unitId, unit: $unit)
    removeUnitExternalReferences(
      propertyId: $propertyId
      unitId: $unitId
      externalReferences: $removeExternalReferences
    ) {
      id
      direct
      source {
        sourceEntityId
        sourceEntityType
        sourceType
      }
      relationshipSource {
        sourceType
        sourceRelationshipType
        sourceRelationshipId
      }
    }
    addUnitExternalReferences(
      propertyId: $propertyId
      unitId: $unitId
      externalReferences: $addExternalReferences
    ) {
      id
      direct
      source {
        sourceEntityId
        sourceEntityType
        sourceType
      }
      relationshipSource {
        sourceType
        sourceRelationshipType
        sourceRelationshipId
      }
    }
  }
`);
